<template>
  <div>
    <!-- <div class="d-flex justify-center body pt-4 ma-2">
      <span class="font-16 w-700">“นโยบายการคุ้มครองข้อมูลส่วนบุคคลสำหรับลูกค้าและผู้ใช้บริการ <br />
        <span class="font-16 w-700 d-flex justify-center">
          (Data Protection Policy for Customers and Clients)”
        </span>
      </span>
    </div> -->
    <!-- 1 -->
    <div class="body pt-4 mb-3">
      <div class="paragraph-2em">
        <span
          >การจัดเก็บข้อมูลส่วนบุคคลไว้บนระบบ tele-consulting
          มีความมุ่งมั่นที่จะดำเนินการตามพระราชบัญญัติ คุ้มครองข้อมูลส่วนบุคคล
          พ.ศ. 2562 กฎหมายลำดับรอง ประกาศ ระเบียบ แนวทางและ/หรือคำสั่งของ
          คณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
          จึงได้กำหนดหลักเกณฑ์และหลักปฏิบัติในการเก็บรวบรวม ใช้ ประมวลผล
          และเปิดเผยข้อมูลส่วนบุคคลและการคุ้มครองสิทธิของเจ้าของข้อมูลส่วนบุคคล
          และขอให้เจ้าของข้อมูลส่วนบุคคล
          ศึกษารายละเอียดและเงื่อนไขของหนังสือแสดงความยินยอม (Consent Form)
          ของข้อมูลส่วนบุคคลฉบับนี้โดย ละเอียด
        </span>
      </div>

      <div class="pt-3">
        1. วัตถุประสงค์ในการเก็บรวบรวม/ใช้/เปิดเผย ข้อมูลส่วนบุคคล
      </div>
      <div class="sub paragraph-2em">
        <span
          >ในกรณีที่ท่านสร้างบัญชี (User Account) หรือประวัติส่วนตัว (Profile)
          กับระบบ One Platform ของ บริษัท ดิจิตอล เฮลท์ อินฟอร์เมติคส์ จำกัด
          (“บริษัท”) ข้อมูลส่วนบุคคลของท่านจะ ถูกเก็บไว้และอาจถูกใช้
          เพื่อวัตถุประสงค์ดังต่อไปนี้
        </span>
      </div>
      <div>
        <div class="sub">
          1.1 เพื่อเป็นการเข้าใช้งาน ระบบ tele-consulting
          ซึ่งเป็นระบบการให้คำปรึกษาการแพทย์ ทางไกล (Telemedicine) ผ่าน Video
          Conference
        </div>
        <div class="sub">
          1.2 เพื่อเป็นการเข้าใช้งาน ลงทะเบียน พิสูจน์และยืนยันตัวตน
          ในการเข้าใช้งาน ระบบ tele-consulting เพื่อการแพทย์ทางไกล
          (Telemedicine) ผ่าน Video Conference
        </div>
      </div>

      <div>
        2.
        เพื่อใช้เป็นข้อมูลให้แพทย์และเจ้าหน้าที่ที่เกี่ยวข้องได้วิเคราะห์อาการเจ็บป่วยต่าง
        ๆ ให้คำปรึกษา และติดตามอาการได้อย่างเหมาะสม
        บริษัทจึงขอทำการบันทึกภาพและเสียงสนทนาของท่านขณะใช้บริการ ระบบ
        tele-consulting ซึ่งเป็นระบบการให้คำปรึกษาการแพทย์ทางไกล ผ่าน Video
        Conference
      </div>

      <div>
        3. เพื่ออำนวยความสะดวกให้เจ้าหน้าที่
        ที่เกี่ยวข้องใช้เป็นข้อมูลสำหรับการยืนยันตัวตนของผู้ป่วย
        และใช้เป็นหลักฐานในการเบิกเคลมประกัน (ถ้ามี)
        บริษัทจึงขอทำการบันทึกภาพถ่ายผู้ป่วยที่ถ่ายคู่กับบัตรประชาชน
        และจัดเก็บไว้บนระบบ One box ที่โรงพยาบาลได้เช่าใช้บริการ
      </div>

      <div>
        4. เพื่อใช้สำหรับการพัฒนา และปรับปรุงคุณภาพการให้บริการของ ระบบ
        tele-consulting (ผู้ใช้บริการ) ซึ่งเป็นระบบการให้คำปรึกษาการแพทย์ทางไกล
        (Telemedicine) ผ่าน Video Conference ทั้งนี้ยังมี
        การแนะนำการใช้ยารักษาให้แก่ผู้ป่วย
        หากภายหลังมีการเปลี่ยนแปลงวัตถุประสงค์ในการเก็บรวบรวม ข้อมูลส่วนบุคคล
        บริษัทจะแจ้งให้ท่านทราบและขอความยินยอมจากท่านเพิ่มเติม
      </div>
      <!-- <div class="sub">
        4.1 ข้อมูลที่ท่านให้ไว้ตามเอกสารความยินยอมในการเก็บรวบรวม ใช้
        หรือเปิดเผยข้อมูลส่วนบุคคล สำหรับระบบ tele-consulting
        ซึ่งเป็นระบบการให้คำปรึกษาการแพทย์ทางไกล (Telemedicine) ผ่าน Video
        Conference (ผู้ใช้บริการ)
        <div class="sub_body">
          4.1.1. ข้อมูลส่วนตัว ได้แก่ ชื่อ-นามสกุล, เพศ, วันเกิด, อายุ,
          เบอร์โทรศัพท์, อีเมล, เลขบัตร ประชาชน/เลขที่หนังสือเดินทาง, ที่อยู่,
          สัญชาติ, หมู่เลือด, สถานภาพสมรส, สถานที่ทำงาน, เชื้อ ชาติ, ศาสนา,
          อาชีพ, สถานที่ทำงาน, รูปถ่าย/วีดีโอ
        </div>
        <div class="sub_body">
          4.1.2. ข้อมูลผู้ติดต่อได้ในกรณีฉุกเฉิน ได้แก่ ชื่อ-นามสกุล
          บิดา,ชื่อ-นามสกุล มารดา, ชื่อ-นามสกุล คู่สมรส (ถ้ามี),
          ข้อมูลญาติที่ติดต่อได้, ความสัมพันธ์ญาติ, เบอร์ติดต่อญาติ, ที่อยู่ญาติ
        </div>
        <div class="sub_body">
          4.1.3. ข้อมูลประวัติการรักษา ได้แก่ อาการสำคัญ, อาการปัจจุบัน,
          บันทึกทางการแพทย์, โรค ประจำตัว, โรคประจำตัว, แพ้ยา (ชื่อยา),
          อาการแพ้ยา, ประวัติการรักษา, บันทึกสุขภาพ, ประวัติ การฉีดวัคซีน,
          บันทึก Covid Tracking, วิดีโอบันทึกการรักษา
        </div>
        <div class="sub_body">
          4.1.4. ข้อมูลประวัติการนัดหมาย ได้แก่ ปฏิทินการนัดหมาย,
          ประวัติการนัดหมาย
        </div>
      </div>
      <div class="sub">
        4.2 เมื่อท่านติดต่อบริษัท
        บริษัทอาจขอข้อมูลเพื่อยืนยันตัวตนของท่านและข้อมูลที่ท่านสอบถามเพื่อจะได้
        ตอบกลับได้อย่างถูกต้อง ทั้งนี้
        บริษัทอาจบันทึกข้อมูลการติดต่อของท่านในระบบของบริษัท
      </div>
      <div class="sub">
        4.3 ข้อจำกัดในการนำข้อมูลส่วนบุคคลไปใช้
        <div class="sub_body">
          4.3.1 บริษัทจะเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ตามข้อ 1 เท่านั้น
        </div>
        <div class="sub_body">
          4.3.2 บริษัทจะดูแลไม่ให้ผู้ปฏิบัติงานของบริษัทเปิดเผย แสดง
          หรือทำให้ปรากฏในลักษณะอื่นใดซึ่ง ข้อมูลส่วนบุคคลของท่านต่อบุคคลภายนอก
          เว้นแต่ ได้รับความยินยอมเป็นหนังสือจากท่าน, เป็น กรณีที่กฎหมายกำหนด,
          เป็นไปเพื่อประโยชน์ของท่าน และการขอความยินยอมไม่อาจกระทำได้ใน
          เวลานั้น, เป็นไปเพื่อประโยชน์เกี่ยวกับชีวิต สุขภาพ
          หรือความปลอดภัยของท่านและผู้ใช้บริการท่าน อื่น,
          เพื่อประโยชน์แก่การสอบสวนของพนักงานสอบสวน
          หรือการพิจารณาพิพากษาคดีของศาล, เพื่อประโยชน์ในการศึกษา วิจัย
          หรือการจัดทำสถิติ
        </div>
        <div class="sub_body">
          4.3.3 ในบางกรณีบริษัทอาจกำหนดให้บุคคลหรือนิติบุคคลที่เป็นผู้รับจ้าง
          เก็บรักษาข้อมูลส่วนบุคคล ดำเนินการใดๆ
          เพื่อรักษาความปลอดภัยของข้อมูลของท่าน
          โดยห้ามนำข้อมูลไปใช้นอกเหนือจากที่ กำหนดให้ดำเนินการ
        </div>
      </div>
      <div class="sub">
        4.4 การรักษาความมั่นคงปลอดภัย
        <div class="sub_body">
          บริษัทกำหนดให้มีมาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลอย่างเหมาะสม
          และสอดคล้องกับ การรักษาความลับของข้อมูลส่วนบุคคล เพื่อป้องกันการสูญหาย
          การเข้าถึง ทำลาย ใช้ แปลง
          แก้ไขหรือเปิดเผยข้อมูลส่วนบุคคลโดยไม่มีสิทธิหรือโดยไม่ชอบด้วยกฎหมาย
          โดยให้เป็นไปตามที่
          กำหนดในนโยบายเรื่องการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล
        </div>
      </div> -->

      <div>5. ข้อมูลที่เจ้าของข้อมูลให้ไว้โดยตรง</div>
      <div class="sub">
        5.1 ข้อมูลที่ท่านให้ไว้ตามเอกสารความยินยอมในการเก็บรวบรวม ใช้
        หรือเปิดเผยข้อมูลส่วนบุคคล สำหรับระบบ tele-consulting
        ซึ่งเป็นระบบการให้คำปรึกษาการแพทย์ทางไกล (Telemedicine) ผ่าน Video
        Conference (ผู้ใช้บริการ)
        <div class="sub_body">
          5.1.1. ข้อมูลส่วนตัว ได้แก่ ชื่อ-นามสกุล, เพศ, วันเกิด, อายุ,
          เบอร์โทรศัพท์, อีเมล, เลขบัตรประชาชน/เลขที่หนังสือเดินทาง, ที่อยู่,
          สัญชาติ, หมู่เลือด, สถานภาพสมรส, สถานที่ทำงาน, เชื้อชาติ, ศาสนา,
          อาชีพ, สถานที่ทำงาน, รูปถ่าย/วีดีโอ
        </div>
        <div class="sub_body">
          5.1.2. ข้อมูลผู้ติดต่อได้ในกรณีฉุกเฉิน ได้แก่ ชื่อ-นามสกุล
          บิดา,ชื่อ-นามสกุล มารดา, ชื่อ-นามสกุล คู่สมรส (ถ้ามี),
          ข้อมูลญาติที่ติดต่อได้, ความสัมพันธ์ญาติ, เบอร์ติดต่อญาติ, ที่อยู่ญาติ
        </div>
        <div class="sub_body">
          5.1.3. ข้อมูลประวัติการรักษา ได้แก่ อาการสำคัญ, อาการปัจจุบัน,
          บันทึกทางการแพทย์, โรคประจำตัว, โรคประจำตัว, แพ้ยา (ชื่อยา),
          อาการแพ้ยา, ประวัติการรักษา, บันทึกสุขภาพ, ประวัติการฉีดวัคซีน, บันทึก
          Covid Tracking, วิดีโอบันทึกการรักษา
        </div>
        <div class="sub_body">
          5.1.4. ข้อมูลประวัติการนัดหมาย ได้แก่ ปฏิทินการนัดหมาย,
          ประวัติการนัดหมาย
        </div>
      </div>
      <div class="sub">
        5.2 เมื่อท่านติดต่อบริษัท
        บริษัทอาจขอข้อมูลเพื่อยืนยันตัวตนของท่านและข้อมูลที่ท่านสอบถามเพื่อจะได้ตอบกลับได้อย่างถูกต้อง
        ทั้งนี้ บริษัทอาจบันทึกข้อมูลการติดต่อของท่านในระบบของบริษัท
      </div>
      <div class="sub">
        5.3 ข้อจำกัดในการนำข้อมูลส่วนบุคคลไปใช้
        <div class="sub_body">
          5.3.1 บริษัทจะเก็บรวบรวม ใช้
          และเปิดเผยข้อมูลส่วนบุคคลของท่านเพื่อวัตถุประสงค์ตามข้อ1เท่านั้น
        </div>
        <div class="sub_body">
          5.3.2 บริษัทจะดูแลไม่ให้ผู้ปฏิบัติงานของบริษัทเปิดเผย แสดง
          หรือทำให้ปรากฏในลักษณะอื่นใดซึ่งข้อมูลส่วนบุคคลของท่านต่อบุคคลภายนอก
          เว้นแต่ ได้รับความยินยอมเป็นหนังสือจากท่าน, เป็นกรณีที่กฎหมายกำหนด,
          เป็นไปเพื่อประโยชน์ของท่าน และการขอความยินยอมไม่อาจกระทำได้ใน
          เวลานั้น, เป็นไปเพื่อประโยชน์เกี่ยวกับชีวิต สุขภาพ
          หรือความปลอดภัยของท่านและผู้ใช้บริการท่าน อื่น,
          เพื่อประโยชน์แก่การสอบสวนของพนักงานสอบสวน
          หรือการพิจารณาพิพากษาคดีของศาล, เพื่อประโยชน์ในการศึกษา วิจัย
          หรือการจัดทำสถิติ
        </div>
        <div class="sub_body">
          5.3.3 ในบางกรณีบริษัทอาจกำหนดให้บุคคลหรือนิติบุคคลที่เป็นผู้รับจ้าง
          เก็บรักษาข้อมูลส่วนบุคคล ดำเนินการใดๆ
          เพื่อรักษาความปลอดภัยของข้อมูลของท่าน
          โดยห้ามนำข้อมูลไปใช้นอกเหนือจากที่ กำหนดให้ดำเนินการ
        </div>
      </div>
      <div class="sub">
        5.4 การรักษาความมั่นคงปลอดภัย
        <div class="sub_body">
          บริษัทกำหนดให้มีมาตรการในการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลอย่างเหมาะสมและสอดคล้องกับ
          การรักษาความลับของข้อมูลส่วนบุคคล เพื่อป้องกันการสูญหาย การเข้าถึง
          ทำลาย ใช้แปลง
          แก้ไขหรือเปิดเผยข้อมูลส่วนบุคคลโดยไม่มีสิทธิหรือโดยไม่ชอบด้วยกฎหมาย
          โดยให้เป็นไปตามที่
          กำหนดในนโยบายเรื่องการรักษาความมั่นคงปลอดภัยข้อมูลส่วนบุคคล
        </div>
      </div>

      <div>6. สิทธิของเจ้าของข้อมูล</div>
      <div class="sub">
        6.1
        ท่านมีสิทธิในความเป็นส่วนตัวของข้อมูลส่วนบุคคลของท่านในการเลือกว่าจะให้บริษัทเก็บรวบรวม
        จัดเก็บ ใช้ เปิดเผยหรือไม่ให้เก็บรวบรวม จัดเก็บ ใช้
        เปิดเผยข้อมูลส่วนบุคคลดังกล่าว ทั้งนี้ การดำเนินการ
        อื่นใดกับข้อมูลส่วนบุคคลของท่าน
        นอกเหนือจากวัตถุประสงค์ที่ระบุไว้ข้างต้นจะต้องได้รับความยินยอมจาก
        ท่านเพิ่มเติม
      </div>
      <div class="sub">
        6.2 ท่านมีสิทธิขอดูและรับสำเนาข้อมูลส่วนบุคคลที่บริษัทได้เก็บรวบรวม ใช้
        เปิดเผย โดยหากมีข้อมูลส่วน
        บุคคลที่บริษัทได้มาโดยไม่ได้รับความยินยอมจากท่าน
        ท่านสามารถขอให้บริษัทเปิดเผยวิธีการได้มาได้ และ
        หากเป็นการเก็บรวบรวมข้อมูลส่วนบุคคลจากแหล่งอื่น เช่น
        ช่องทางสื่อสังคมออนไลน์หรือเว็บไซต์ เป็นต้น
        ท่านมีสิทธิขอให้ลบหรือทำลายข้อมูล ระงับ
        หรือทำให้ข้อมูลไม่สามารถระบุตัวตนได้ ในกรณีที่บริษัทได้ใช้
        ข้อมูลส่วนบุคคลไม่เป็นไปตามวัตถุประสงค์ที่แจ้งไว้
        ท่านมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคล และท่านมี
        สิทธิขอแก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้องเป็นปัจจุบันสมบูรณ์ได้
      </div>
      <div class="sub">
        6.3 ท่านมีสิทธิในการลบข้อมูลส่วนบุคคล โดยท่านมีสิทธิขอให้บริษัท ฯ
        ดำเนินการลบ หรือทำลาย หรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่
        สามารถระบุตัวบุคคลที่เป็นท่านได้ ในกรณีดังต่อไปนี้
        <div class="sub_body">
          (1)
          เมื่อข้อมูลส่วนบุคคลหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ในการเก็บรวบรวม
          ใช้หรือเปิดเผยข้อมูลส่วนบุคคล
        </div>
        <div class="sub_body">
          (2) เมื่อท่านถอนความยินยอมในการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลและบริษัท ฯ
          ไม่มีอำนาจตามกฎหมายที่จะเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลนั้นได้ต่อไป
        </div>
        <div class="sub_body">
          (3) เมื่อท่านคัดค้านการเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคล
          และบริษัท ฯ ไม่อาจปฏิเสธคำขอตาม หรือเป็นการคัดค้านตามกฎหมาย
        </div>
        <div class="sub_body">
          (4) เมื่อข้อมูลส่วนบุคคลได้ถูกเก็บรวบรวม ใช้
          หรือเปิดเผยโดยไม่ชอบด้วยกฎหมายตามที่กำหนดไว้
          ในกรณีที่เป็นการเก็บรักษาไว้เพื่อวัตถุประสงค์ในการใช้เสรีภาพในการแสดงความคิดเห็น
          การเก็บรักษาไว้เพื่อวัตถุประสงค์ตามกฎหมาย การใช้เพื่อการก่อตั้ง
          สิทธิเรียกร้องตามกฎหมาย การปฏิบัติตาม
          หรือการใช้สิทธิเรียกร้องตามกฎหมาย หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตาม
          กฎหมาย หรือเพื่อการปฏิบัติตามกฎหมาย ในกรณีที่บริษัท ฯ
          ได้ทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่เปิดเผยต่อสาธารณะ และบริษัท ฯ
          ถูกขอให้ลบหรือทำลายหรือทำให้ข้อมูลส่วนบุคคลเป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นท่านได้
        </div>
      </div>
      <div class="sub">
        6.4 สิทธิในการขอให้ระงับการใช้ข้อมูลส่วนบุคคลท่านมีสิทธิขอให้บริษัท ฯ
        ระงับการใช้ข้อมูลส่วนบุคคลได้ในกรณี ดังต่อไปนี้
        <div class="sub_body">
          (1) เมื่อบริษัท ฯ อยู่ในระหว่างการตรวจสอบตามที่ท่าน ร้องขอให้ดำเนินการ
          ตามกฎหมาย
        </div>
        <div class="sub_body">
          (2) เมื่อเป็นข้อมูลส่วนบุคคลที่ต้องลบหรือทำลาย
          แต่ท่านขอให้ระงับการใช้แทน
        </div>
        <div class="sub_body">
          (3)
          เมื่อข้อมูลส่วนบุคคลหมดความจำเป็นในการเก็บรักษาไว้ตามวัตถุประสงค์ในการเก็บรวบรวม
          ข้อมูลส่วนบุคคล
          แต่ท่านมีความจำเป็นต้องขอให้เก็บรักษาไว้เพื่อใช้ในการก่อตั้ง
          สิทธิเรียกร้องตามกฎหมาย การปฏิบัติ
          ตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย
          หรือการยกขึ้นต่อสู้สิทธิเรียกร้องตามกฎหมาย
        </div>
        <div class="sub_body">
          (4) เมื่อบริษัท ฯ อยู่ในระหว่างการพิสูจน์ตามกฎหมาย
          เพื่อปฏิเสธการคัดค้านของท่านตามมาตรา ๓๒ วรรคสาม กรณีผู้บริษัท ฯ
          ไม่ดำเนินการตามข้างต้น
          ท่านมีสิทธิรองเรียนต่อคณะกรรมการผู้เชี่ยวชาญเพื่อสั่งให้บริษัท ฯ
          ดำเนินการได้
        </div>
      </div>
      <div class="sub">
        6.5 สิทธิในการคัดค้านการประมวลผลข้อมูลส่วนบุคคล
        ท่านมีสิทธิคัดค้านการเก็บรวบรวม ใช้
        หรือเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวกับตนเมื่อใดก็ ได้ดังต่อไปนี้
        <div class="sub_body">
          (1)
          กรณีที่เป็นข้อมูลส่วนบุคคลที่เก็บรวบรวมได้โดยได้รับยกเว้นไม่ต้องขอความยินยอม
          เว้นแต่บริษัท ฯพิสูจน์ได้ว่า
          <div class="sub_body">
            (ก) การเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูลส่วนบุคคลนั้น บริษัท ฯ
            ได้แสดงให้เห็นถึงเหตุอัน ชอบด้วยกฎหมายที่สำคัญยิ่งกว่า
          </div>
          <div class="sub_body">
            (ข) การเก็บรวบรวม ใช้
            หรือเปิดเผยข้อมูลส่วนบุคคลนั้นเป็นไปเพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมาย
            การ ปฏิบัติตามหรือการใช้สิทธิเรียกร้องตามกฎหมาย
            หรือการยกขึ้นต่อสู้สิทธิเรียกร้อง ตามกฎหมาย
          </div>
        </div>
        <div class="sub_body">
          (2) กรณีที่เป็นการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์เกี่ยวกับ การตลาดแบบตรง
        </div>
        <div class="sub_body">
          (3) กรณีที่เป็นการเก็บรวบรวม ใช้
          หรือเปิดเผยข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์เกี่ยวกับ
          การศึกษาวิจัยทางวิทยาศาสตร์ ประวัติศาสตร์ หรือสถิติ
          เว้นแต่เป็นการจำเป็นเพื่อการดำเนินภารกิจ เพื่อประโยชน์สาธารณะของบริษัท
          ฯ
          <div class="sub_body paragraph-2em">
            ในกรณีที่ท่านใช้สิทธิคัดค้านตามวรรคหนึ่ง บริษัท ฯ
            ไม่สามารถเก็บรวบรวม ใช้ หรือเปิดเผยข้อมูล ส่วนบุคคลนั้นต่อไปได้
            ทั้งนี้ บริษัท ฯ
            จะปฏิบัติโดยแยกส่วนออกจากข้อมูลอื่นอย่างชัดเจนในทันทีเมื่อท่านได้แจ้งการคัดค้านให้บริษัท
            ฯ ทราบ ในกรณีที่บริษัท ฯ ปฏิเสธการคัดด้านด้วยเหตุผลตาม (1) (ก) หรือ
            (ข) หรือ (3) บริษัท ฯ
            จะบันทึกการปฏิเสธการคัดค้านพร้อมด้วยเหตุผลไว้ในรายการ ตามกฎหมาย
          </div>
        </div>
      </div>
      <div class="sub">
        6.6 สิทธิในการขอให้โอนย้ายข้อมูลส่วนบุคคล
        ท่านมีสิทธิขอรับข้อมูลส่วนบุคคลที่เกี่ยวกับตนจากบริษัท ฯ ได้
        ในกรณีที่บริษัท ฯ
        ได้ทำให้ข้อมูลส่วนบุคคลนั้นอยู่ในรูปแบบที่สามารถอ่านหรือใช้งานโดยทั่วไปได้ด้วยเครื่องมือ
        หรืออุปกรณ์ที่ทำงานได้โดยอัตโนมัติและสามารถใช้หรือเปิดเผยข้อมูลส่วนบุคคลได้ด้วยวิธีการอัตโนมัติ
        รวมทั้งมีสิทธิ ดังต่อไปนี้
        <div class="sub_body">
          (1) ขอให้บริษัท ฯ
          ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น
          เมื่อสามารถทำได้ด้วยวิธีการอัตโนมัติ
        </div>
        <div class="sub_body">
          (2) ขอรับข้อมูลส่วนบุคคลที่บริษัท ฯ ส่งหรือโอนข้อมูลส่วนบุคคลในรูปแบบ
          ดังกล่าวไปยังผู้ควบคุม ข้อมูลส่วนบุคคลอื่นโดยตรง
          เว้นแต่โดยสภาพทางเทคนิคไม่สามารถทำได้ ข้อมูลส่วนบุคคลตามวรรค
          หนึ่งต้องเป็นข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมในการเก็บ รวบรวม
          ใช้ หรือเปิดเผยข้อมูล ส่วนบุคคลตามหลักเกณฑ์แห่งพระราชบัญญัตินี้
          หรือเป็นข้อมูลส่วนบุคคลที่ได้รับยกเว้นไม่ต้องขอ ความยินยอม
          หรือเป็นข้อมูลส่วนบุคคลอื่นที่กำหนดในกฎหมาย ตามที่คณะกรรมการประกาศ
          กำหนด
          การใช้สิทธิของท่านตามวรรคหนึ่งจะใช้กับการส่งหรือโอนข้อมูลส่วนบุคคล
          ของบริษัท ฯ ซึ่ง
          เป็นการปฏิบัติหน้าที่เพื่อประโยชน์สาธารณะหรือเป็นการปฏิบัติหน้าที่
          ตามกฎหมายไม่ได้ หรือการ ใช้สิทธิ
          นั้นต้องไม่ละเมิดสิทธิหรือเสรีภาพของบุคคลอื่น ทั้งนี้
          ในกรณีที่ผู้บริษัท ฯ ปฏิเสธคำขอด้วย เหตุผลดังกล่าว บริษัท ฯ
          จะบันทึกการปฏิเสธคำขอ พร้อมด้วยเหตุผลไว้ในรายการตามกฎหมาย
        </div>
      </div>
      <div class="sub">
        6.7 สิทธิในการขอเพิกถอนความยินยอม
        <div class="sub_body">
          ในกรณีที่ท่านร้องขอให้บริษัท ฯ ดำเนินการให้ข้อมูลส่วนบุคคลเป็นปัจจุบัน
          หากบริษัท ฯ ไม่ดำเนินการตามคำร้องขอ บริษัท
          ฯจะต้องบันทึกคำร้องขอของท่านพร้อมด้วยเหตุผลไว้ในรายการตามกฎหมาย
        </div>
      </div>
      <div class="sub">
        6.8 ท่านสามารถแจ้งความประสงค์การดำเนินการตามข้อ 5.1 ถึงข้อ 5.7 ได้
        โดยแจ้งมายัง info@dhi.co.th
      </div>

      <div>7. ระยะเวลาการเก็บข้อมูล</div>
      <div class="sub paragraph-2em">
        บริษัทจะจัดเก็บ ใช้ และเปิดเผยข้อมูลส่วนบุคคลของท่าน และข้อมูลอื่น ๆ
        เท่าที่จำเป็น เป็นระยะเวลา 2 ปี ในการใช้ระบบ tele-consulting
        (ผู้ใช้บริการ) ซึ่งเป็นระบบการให้คำปรึกษาการแพทย์ทางไกล (Telemedicine)
        ผ่าน Video Conference
        หรือจนกว่าท่านจะยกเลิกบัญชีหรือขอยกเลิกการให้ความยินยอม
      </div>
      <div>8. กรณีบริษัทแบ่งปันข้อมูลของท่านให้แก่บุคคลที่สาม</div>

      <div class="sub paragraph-2em">
        บริษัทจะเปิดเผยข้อมูลของท่านแก่บุคคลที่สามใด ๆ
        ที่จำเป็นต้องใช้ข้อมูลดังกล่าวเพื่อวัตถุประสงค์ตามข้อ 1
        หรือเพื่อให้บริการ หรือเพื่อช่วยดำเนินการตามคำขอของท่านเท่านั้น
        โดยบุคคลที่สามหมายความรวมถึง
        <div class="sub_body">
          8.1. หน่วยงานใด ๆ ของกลุ่มบริษัท ดิจิตอล เฮลท์ อินฟอร์เมติคส์ จำกัด
          และบริษัทในเครือ
        </div>
        <div class="sub_body">
          8.2. โรงพยาบาลที่เกี่ยวข้องสำหรับการใช้บริการระบบ tele-consulting
          ซึ่งเป็นระบบการให้คำปรึกษาการแพทย์ทางไกล (Telemedicine) ผ่าน Video
          Conference ให้แก่ท่าน
        </div>
      </div>
      <div>
        9. บุคคลอื่น ๆ
        เมื่อมีกฎหมายกำหนดไว้หรือมีความจำเป็นที่จะคุ้มครองบริการของบริษัท เช่น
        เมื่อกฎหมายกระบวนการทางกฎหมาย
        หรือคำสั่งศาลจากเจ้าหน้าที่ภาครัฐผู้มีอำนาจ
        บังคับให้เปิดเผยข้อมูลของท่าน นอกจากนี้
        ยังอาจมีการขอข้อมูลของท่านเพื่อวัตถุประสงค์ในการบังคับใช้กฎหมาย
        ความปลอดภัยของชาติ
      </div>
      <div class="sub paragraph-2em">
        ทั้งนี้ก่อนการแสดงเจตนา เจ้าของข้อมูลส่วนบุคคล
        ได้อ่านรายละเอียดเกี่ยวกับหนังสือแสดงความยินยอม
        ฉบับนี้และได้รับทราบและเข้าใจดีถึงวัตถุประสงค์ในการเก็บรวบรวม
        ใช้หรือเปิดเผย (การประมวลผล) ข้อมูล ส่วน บุคคลของเจ้าของข้อมูลส่วนบุคคล
        ดังกล่าว
      </div>
      <div class="sub paragraph-2em">
        เจ้าของข้อมูลส่วนบุคคล
        ได้ให้ความยินยอมหรือปฏิเสธไม่ให้ความยินยอมในหนังสือแสดงความยินยอมฉบับนี้
        ด้วยความสมัครใจปราศจากการหลอกลวง การบังคับหรือการชักจูง
        หรือทำให้เข้าใจผิดในวัตถุประสงค์ของการเก็บ
        รวบรวม/ใช้/เปิดเผยข้อมูลส่วนบุคคลแต่อย่างใด
        และเจ้าหน้าที่ได้แจ้งผู้ให้เจ้าของข้อมูลส่วนบุคคล ทราบแล้วว่า
        ผู้ให้เจ้าของข้อมูลส่วนบุคคล
        สามารถถอนความยินยอมนี้เสียเมื่อใดก็ได้เว้นแต่ในกรณีมีข้อจำกัดสิทธิในการให้ความ
        ยินยอมโดยกฎหมายหรือสัญญาที่ให้ประโยชน์แก่เจ้าของข้อมูลส่วนบุคคล
      </div>
      <div class="sub paragraph-2em">
        ทั้งนี้เอกสารแสดงความยินยอมฉบับนี้จะมีการจัดเก็บไว้ตามที่กฎหมายกำหนดหรือจนกว่าจะมีการ
        ร้องขอให้ทำลาย นับตั้งแต่วันที่ได้กดแสดงความยินยอมในเอกสารฉบับนี้
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    gotopage() {
      window.open("https://www.inet.co.th");
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 16px !important;
  color: #000;
}

h2 {
  font-size: 14px !important;
  color: #000;
}

.body {
  margin-top: 10px;
  padding-left: 30px;
}

.body_body span {
  padding-left: 10px;
}

.sub {
  padding-left: 30px;
}

.sub_body {
  padding-left: 20px;
}
.paragraph-2em {
  text-indent: 2em;
}
</style>
